import type { AppLocale } from "../app-locale";
import { enMessages } from "./en";
import { koMessages, type MessageCatalog } from "./ko";

export type { MessageCatalog, TranslationKey } from "./ko";

export const messageCatalogs: Record<AppLocale, MessageCatalog> = {
  ko: koMessages,
  en: enMessages,
};
